import { createContext } from "react";
import EventEmitter from "eventemitter3";
/**
 *  Context for event emitter for configuration events
 * @private For internal use only
 */
export const ConfigurationEventEmitterContext = createContext(new EventEmitter());
ConfigurationEventEmitterContext.displayName =
    "ConfigurationEventEmitterContext";
/**
 * Constant for configuration events
 * @private For internal use only
 */
export const CFG_EVENT = "cfgEvent";
//# sourceMappingURL=ConfigurationEventEmitterContext.js.map